var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: [this.namespace(), _vm.skinStyle] },
    [
      _c(
        "div",
        { class: [_vm.namespace("button-group"), _vm.mdsNS("button-group")] },
        [
          _vm._l(_vm.showItems, function(item) {
            return _c(
              "div",
              {
                key: item.id,
                class: [
                  _vm.namespace("button"),
                  _vm.mdsNS("button button--secondary"),
                  item.isActive
                    ? _vm.namespace("tab--active") +
                      " " +
                      _vm.mdsNS("button--active")
                    : ""
                ],
                attrs: { role: "button" },
                on: {
                  click: function($event) {
                    return _vm.tabClicked(item, $event)
                  }
                }
              },
              [
                _c("span", { class: _vm.namespace("button-text") }, [
                  _vm._v(_vm._s(item.name))
                ]),
                _vm._v(" "),
                item.isActive && item.editable
                  ? _c(
                      "span",
                      {
                        class: [
                          _vm.namespace("popover-handler"),
                          _vm.namespace("edit-icon")
                        ]
                      },
                      [
                        _c(
                          "svg",
                          {
                            class: [
                              _vm.mdsNS(
                                "icon button__icon button__icon--right"
                              ),
                              _vm.namespace("edit-icon")
                            ],
                            attrs: { "aria-hidden": "true" }
                          },
                          [
                            _c("use", {
                              attrs: { "xlink:href": "#caret-down--s" }
                            })
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _vm.showMoreItems
            ? _c(
                "div",
                {
                  class: [
                    _vm.namespace("button"),
                    _vm.namespace("button--more"),
                    _vm.mdsNS("button button--secondary")
                  ],
                  attrs: { type: "button", role: "button" },
                  on: {
                    click: function($event) {
                      return _vm.moreMenuClicked($event)
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      class: _vm.mdsNS("icon button__icon button__icon--left"),
                      attrs: { "aria-hidden": "true" }
                    },
                    [
                      _c("use", {
                        attrs: { "xlink:href": "#ellipsis-horizontal" }
                      })
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showAddIcon
            ? _c(
                "div",
                {
                  ref: "addIcon",
                  class: [
                    _vm.namespace("button"),
                    _vm.namespace("button--add"),
                    _vm.mdsNS("button button--secondary")
                  ],
                  attrs: { type: "button", role: "button" },
                  on: {
                    click: function($event) {
                      return _vm.addTab($event)
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      class: _vm.mdsNS("icon button__icon button__icon--left"),
                      attrs: { "aria-hidden": "true" }
                    },
                    [_c("use", { attrs: { "xlink:href": "#plus" } })]
                  )
                ]
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "markets-ui-settings",
        {
          class: _vm.namespace("popover"),
          attrs: {
            target: _vm.popoverTarget,
            namespaced: _vm.namespaced,
            skin: _vm.skin,
            visible: _vm.popoverOptions.visible,
            title: _vm.popoverOptions.title,
            width: _vm.popoverOptions.width
          },
          on: { hide: _vm.hidePopover }
        },
        [
          _c("markets-ui-list", {
            class: _vm.namespace("list"),
            attrs: {
              slot: "content",
              namespaced: _vm.namespaced,
              skin: _vm.skin,
              dataModel: _vm.popoverOptions.list
            },
            on: {
              click: _vm.popoverItemClicked,
              change: _vm.popoverItemClicked
            },
            slot: "content"
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }